import { ModalObservable } from '@base/features/game/model/interfaces';
import { t } from '@base/utils/helpers';
import React from 'react';
import MainButton from '@ui-kit/components/mainButton';
import Modal from '@ui-kit/components/modal';
import styles from '../styles/modalWarning.module.scss';
import classNames from 'classnames';

export default function ModalWarning(props: { modal: ModalObservable }) {
  return (
    <Modal
      title={props.modal.title || t('warning')}
      classes={{body: classNames(props.modal.classes?.body, styles.body), title: props.modal.classes?.title, modal: props.modal.classes?.modal}}
      headerBtn={props.modal.headerBtn}
      closeModal={props.modal.closeModal}
    >
      <div
        className={classNames(props.modal.classes?.title, styles.title)}
      >
        {props.modal.body}
      </div>
      {props.modal.buttons && (
        <footer className={styles.footer}>
          {props.modal.buttons.map((button, index) => (
            <MainButton onClick={() => button.onClick()} key={index}>
              {button.title}
            </MainButton>
          ))}
        </footer>
      )}
    </Modal>
  );
}
